import { render, staticRenderFns } from "./SettlementSetting.vue?vue&type=template&id=42147124&scoped=true&"
import script from "./SettlementSetting.vue?vue&type=script&lang=ts&"
export * from "./SettlementSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SettlementSetting.vue?vue&type=style&index=0&id=42147124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42147124",
  null
  
)

export default component.exports